module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['single', {
      'is-hidden': _vm.singleIsHidden
    }]
  }, [_c('single-header', {
    attrs: {
      "project": _vm.project
    }
  }, [_c('p', [_vm._v("Droplet let's you list your projects with infos like client, date\n        and what language or framework it runs on. It even supports writing\n        project notes in Markdown. An advanced search function is included\n        to quickly find the project you are looking for.")])]), _vm._v(" "), _c('single-section', {
    attrs: {
      "header": "Login Info",
      "info": "",
      "color": _vm.project.color
    }
  }, [_c('p', [_vm._v("To log into the demo use the following credentials:"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Username:")]), _vm._v(" pk"), _c('br'), _vm._v(" "), _c('b', [_vm._v("Password:")]), _vm._v(" pk")])]), _vm._v(" "), _c('single-section', {
    attrs: {
      "header": "Basic Authentication"
    }
  }, [_c('p', [_vm._v("To prevent outsiders to log into the app and manipulate the tables\n        you need to log in. The process is handled dynamically with AJAX and\n        accompanied by smooth transitions.")]), _vm._v(" "), _c('video', {
    attrs: {
      "src": "assets/projects/droplet/login.mp4",
      "autoplay": "",
      "loop": ""
    }
  })]), _vm._v(" "), _c('single-section', {
    attrs: {
      "header": "Creating a Project"
    }
  }, [_c('p', [_vm._v("Notes can be written in Markdown to support basic formatting.")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "assets/projects/droplet/edit-project.jpg"
    }
  })]), _vm._v(" "), _c('single-section', {
    attrs: {
      "header": "Navigating the Tables"
    }
  }, [_c('p', [_vm._v("Shortcuts and in place for easy and fast navigation through the tables\n        and the project creation process. Using the arrow keys moves horizontally and\n        vertically through the tables — walking through the projects.\n        Hitting CMD + N opens the modal for a new project.")]), _vm._v(" "), _c('video', {
    attrs: {
      "src": "assets/projects/droplet/table-navigation.mp4",
      "autoplay": "",
      "loop": ""
    }
  })]), _vm._v(" "), _c('single-section', {
    attrs: {
      "header": "Automatic Project Creation",
      "info": "",
      "color": _vm.project.color
    }
  }, [_c('p', [_vm._v("A planned feature is automatically creating a Droplet project\n        when generating the project readme locally by running a Node script."), _c('br'), _vm._v("\n        The script will ask the user in the terminal all the needed infos and uploads\n            the data with the help of the Laravel API into the database.")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require('Projects/droplet/terminal-feature.png'),
      "alt": "Terminal asking Project Data"
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18faccd6"}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/single/droplet.vue
// module id = 116
// module chunks = 0